import React from "react";
import BtBloco from '../../components/buttons/BtBloco';

class SequenciaBlocos extends React.Component{
  constructor(props){
    super(props);
  }

  render (){
    const _blocos = this.props.blocos;

    const _listBlocos = _blocos.map((bloco,i)=>{
        let _ativo = bloco.ativo;
        let _id = bloco.id;

        return (
          <BtBloco onClick={this.props.onClick} key={i.toString()} value={i+1} ativo={_ativo} dataId={_id}></BtBloco>
        )
      }
    );

    return(
      <div>
        {_listBlocos}
      </div>
    )
  }

}

export default SequenciaBlocos;



// WEBPACK FOOTER //
// ./src/classes/blocos-planilha/SequenciaBlocos.js